/**
 * Homepage value-prop / trust strip (SRS §4.2) — Kenya-specific reassurance that closes
 * the page (below the product rails), so the shop-by-category and product content surface
 * sooner after the hero. Icons are inline SVG in the app's hand-rolled style (no icon lib).
 */
const PROPS: Array<{ label: string; sub: string; icon: JSX.Element }> = [
  {
    label: '100% Genuine',
    sub: 'Authorised distributor',
    icon: <path d="M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6z" />,
  },
  {
    label: 'Delivery by zone',
    sub: 'Rates shown at checkout',
    icon: (
      <>
        <path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" />
        <circle cx="7.5" cy="17" r="1.6" />
        <circle cx="17.5" cy="17" r="1.6" />
      </>
    ),
  },
  {
    label: 'Local support',
    sub: 'Product warranty terms',
    icon: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
  },
  {
    label: 'Checkout options',
    sub: 'Review before you pay',
    icon: (
      <>
        <rect x="6" y="3" width="12" height="18" rx="2" />
        <path d="M11 18h2" />
      </>
    ),
  },
];

export function HomeValueProps(): JSX.Element {
  return (
    <div className="border-t border-frost bg-white">
      <ul className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-4 px-6 py-5 sm:grid-cols-4">
        {PROPS.map((p) => (
          <li key={p.label} className="flex items-center gap-3">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--color-sky-500)"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
              className="shrink-0"
            >
              {p.icon}
            </svg>
            <div className="min-w-0">
              <p className="text-sm font-medium leading-tight text-navy-900">{p.label}</p>
              <p className="text-xs text-neutral">{p.sub}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
